module["exports"] = [
  "#####",
  "#####-####"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en/address/postcode_by_state.js
 ** module id = 403
 ** module chunks = 0
 **/